import types from './actionTypes';

const initialState = {
  loading: false,
  stats: [],
  error: '',
};

const allLeads = (state = initialState, action) => {
  switch (action.type) {
    case types.RESET_DAILY_LEAD_INSIGHT_STATE:
      return initialState;
    case types.DAILY_LEAD_INSIGHTS.REQUEST:
      return {
        ...state,
        loading: true,
        stats: [],
        error: '',
      };
    case types.DAILY_LEAD_INSIGHTS.SUCCESS:
      return {
        ...state,
        loading: false,
        error: '',
        stats: action.stats,
      };
    case types.DAILY_LEAD_INSIGHTS.FAILURE:
      return {
        ...state,
        loading: false,
        error: action.error.message,
      };
    default:
      return state;
  }
};

export default allLeads;
